import type { StripeConnectRouter } from "replo-publisher/src/trpc/routers/stripe-connect";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: stripeConnectRouter,
  client: stripeConnectClient,
  utils: stripeConnectUtils,
  options: stripeConnectOptions,
} = createTrpcRouterConfig<StripeConnectRouter>({
  path: "stripeConnect",
  queryClient: getNamespacedQueryClient("stripeConnect"),
});

export {
  stripeConnectClient,
  stripeConnectRouter,
  stripeConnectUtils,
  stripeConnectOptions,
};
